import type { Action } from 'src/types';
import type { VisibilityLevel } from 'src/types/graphql';

export interface ProfileVisibilityUpdatePayload {
  data: UpdateProfileVisibility;
}

export interface UpdateProfileVisibility {
  ref: string;
}

export type ProfileVisibilityAction =
  | (Action<Actions.PROFILE_VISIBILITY_UPDATE_START> & {
      payload: { level: VisibilityLevel };
    })
  | Action<Actions.PROFILE_VISIBILITY_UPDATE_SUCCESS>
  | (Action<Actions.PROFILE_VISIBILITY_UPDATE_FAILURE> & {
      payload: Error;
    })
  | Action<Actions.PROFILE_VISIBILITY_OPENED>;

export enum Actions {
  PROFILE_VISIBILITY_UPDATE_START = 'PROFILE_VISIBILITY_UPDATE_START',
  PROFILE_VISIBILITY_UPDATE_SUCCESS = 'PROFILE_VISIBILITY_UPDATE_SUCCESS',
  PROFILE_VISIBILITY_UPDATE_FAILURE = 'PROFILE_VISIBILITY_UPDATE_FAILURE',
  PROFILE_VISIBILITY_OPENED = 'PROFILE_VISIBILITY_OPENED',
}
